import React from "react";
import Seo from "@/components/Seo";
import Hero from "@/components/Hero";
import StatsStrip from "@/components/StatsStrip";
import AboutIntro from "@/components/AboutIntro";
import ServicesGrid from "@/components/ServicesGrid";
import LenderMarquee from "@/components/LenderMarquee";
import Calculator from "@/components/Calculator";
import Testimonials from "@/components/Testimonials";
import WhyChooseUs from "@/components/WhyChooseUs";
import CtaStrip from "@/components/CtaStrip";

export default function HomePage() {
    return (
        <div data-testid="page-home">
            <Seo
                title="Mortgage Broker Australia | Finance Wealth"
                description="Australia-wide online mortgage broker helping first home buyers, refinancers and investors compare 60+ lenders. Free consultation with Gurpreet Singh."
                keywords="mortgage broker Australia, online mortgage broker, home loans Australia, refinance broker Australia, investment loans Australia, first home buyer Australia"
            />
            <Hero />
            <StatsStrip />
            <AboutIntro />
            <ServicesGrid />
            <LenderMarquee />
            <Calculator embedded />
            <Testimonials />
            <WhyChooseUs />
            <CtaStrip />
        </div>
    );
}
